/* jshint esversion: 6 */
import utils from '../libs/utils';
import { getOrderDetails } from '@/libs/api'
const group = 'pickup';

const model = {
  ORDER_DETIAL: {}, // 订单详情
  LOGISTICS: {}, // 物流信息
  HISTORY_KEYWORDS_LIST: [], // 历史搜索
};

export const types = utils.genTypes(model, group);
export const state = utils.genState(model, group);
export const getters = utils.genGetters(types);
export const mutations = utils.genMutations(types);



export const actions = {
  // 订单详情
  [types.ORDER_DETIAL](store, query) {
    return getOrderDetails(query).then(res => {
      if (res.returnCode === '0000') {
        res.order = res.data;
        res.orderPrd = res.data.delevery[0].prd[0];
        res.delevery = res.data.delevery[0];
        res.logistics = res.data.logistics[0];
        // 存入物流地址
        store.commit(types.LOGISTICS, res.logistics);
      }
      return res;
    })
  },
  // 存入历史搜索关键字
  [types.HISTORY_KEYWORDS_LIST](store, keyword) {
    let historyList = (JSON.parse(JSON.stringify(store.getters[types.HISTORY_KEYWORDS_LIST])));
    if (historyList.length === 0) {
      historyList.push(keyword)
    }
    else {
      let num = 0;
      historyList.forEach(item => {
        if (item === keyword) {
          num++;
        }
      });
      if (num === 0) {
        historyList.push(keyword);
      }
    }
    store.commit(types.HISTORY_KEYWORDS_LIST, historyList);
  },
}